export const groupByDateRange = (messages) => {
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfYesterday.getDate() - 1);
  const startOfLastWeek = new Date(startOfToday);
  startOfLastWeek.setDate(startOfLastWeek.getDate() - 7);

  const groups = {
    Today: [],
    Yesterday: [],
    "Last Week": [],
    Older: []
  };

  messages.forEach((msg) => {
    const sentDate = new Date(msg.sent);
    if (sentDate >= startOfToday) {
      groups.Today.push(msg);
    } else if (sentDate >= startOfYesterday) {
      groups.Yesterday.push(msg);
    } else if (sentDate >= startOfLastWeek) {
      groups["Last Week"].push(msg);
    } else {
      groups.Older.push(msg);
    }
  });

  // 🔽 Sort each group by descending sent date
  Object.keys(groups).forEach((group) => {
    groups[group].sort((a, b) => new Date(b.sent) - new Date(a.sent));
  });

  return groups;
};